import {useEffect, useState} from 'react';

type DisposableType = {
    dispose: () => void;
}

function useInstance<T>(
  createInstance: () => T & DisposableType,
  dependencies: ReadonlyArray<unknown> = [],
): T | undefined {
  const [instance, setInstance] = useState<T | undefined>();
  useEffect(() => {
    const _instance = createInstance();
    setInstance(_instance);
    return () => {
      if (_instance) {
        _instance.dispose();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
  return instance;
}

export default useInstance;